import React from "react";
import { Button, Upload, App } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import { customUpload } from "../../../utils";
import AudioPlayButton from "./AudioPlayButton";

interface Props {
  value?: string;
  onChange: (url: string | undefined) => void;
  folder?: string;
  label?: string;
  accept?: string;
}

const ACCEPTED_EXTENSIONS = [".mp3", ".wav", ".m4a", ".ogg"];

const AudioUploadInput: React.FC<Props> = ({
  value,
  onChange,
  folder = "game-quiz/audios",
  label = "Subir audio",
  accept = "audio/mpeg,audio/wav,audio/mp3,audio/x-m4a,audio/ogg,.mp3,.wav,.m4a,.ogg",
}) => {
  const { message } = App.useApp();
  const beforeUpload = (file: File): boolean => {
    const name = file.name.toLowerCase();
    const okExt = ACCEPTED_EXTENSIONS.some((ext) => name.endsWith(ext));
    const okMime = file.type.startsWith("audio/");
    if (!okExt && !okMime) {
      message.error("Formato no soportado. Subí MP3, WAV, M4A u OGG.");
      return false;
    }
    return true;
  };

  const handleUpload = async (options: any) => {
    try {
      const { url } = await customUpload(options, folder);
      onChange(url);
      options.onSuccess?.({ url }, options.file);
      message.success("Audio subido");
    } catch (error) {
      console.error(error);
      message.error("Error al subir el audio");
      options.onError?.(error);
    }
  };

  return (
    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
      {value && <AudioPlayButton src={value} size="small" />}
      <Upload
        customRequest={handleUpload}
        beforeUpload={beforeUpload}
        showUploadList={false}
        accept={accept}
      >
        <Button icon={<UploadOutlined />}>{value ? "Reemplazar" : label}</Button>
      </Upload>
      {value && (
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          onClick={() => onChange(undefined)}
        />
      )}
    </div>
  );
};

export default AudioUploadInput;
